import axios from "axios";
import { CONFIG } from "../config";

/**
 * Axios instance for the Trip Registry API (separate service from the main API).
 * Auth interceptors are attached by setupAxiosAuthInterceptor in App.jsx.
 */
export const tripRegistryClient = axios.create({
  baseURL: CONFIG.trip_registry_url,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
});
